export function HierarchyIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      {...props}
    >
      <path
        d="M13.7083 12V7.08333C13.7083 6.625 13.3333 6.25 12.875 6.25H10.4583"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7084 5L10.2084 6.25L11.7084 7.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.29169 8.50002V12"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.4167 8.25C7.31416 8.25 8.04171 7.52247 8.04171 6.62501C8.04171 5.72755 7.31416 5 6.4167 5C5.51923 5 4.79169 5.72755 4.79169 6.62501C4.79169 7.52247 5.51923 8.25 6.4167 8.25Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.29168 15C7.1201 15 7.79167 14.3284 7.79167 13.5C7.79167 12.6716 7.1201 12 6.29168 12C5.46325 12 4.79169 12.6716 4.79169 13.5C4.79169 14.3284 5.46325 15 6.29168 15Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7084 15C14.5368 15 15.2084 14.3284 15.2084 13.5C15.2084 12.6716 14.5368 12 13.7084 12C12.8799 12 12.2084 12.6716 12.2084 13.5C12.2084 14.3284 12.8799 15 13.7084 15Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50002 18.3333H12.5C16.6667 18.3333 18.3334 16.6667 18.3334 12.5V7.50001C18.3334 3.33334 16.6667 1.66667 12.5 1.66667H7.50002C3.33335 1.66667 1.66669 3.33334 1.66669 7.50001V12.5C1.66669 16.6667 3.33335 18.3333 7.50002 18.3333Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ProgramArrowIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.8333 13.3333V5.41667C15.8333 4.5 15.0833 3.75 14.1666 3.75H9.58331"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 1.66669L9.16669 3.75002L11.6667 5.83335"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8333 18.3333C17.214 18.3333 18.3333 17.214 18.3333 15.8333C18.3333 14.4526 17.214 13.3333 15.8333 13.3333C14.4526 13.3333 13.3333 14.4526 13.3333 15.8333C13.3333 17.214 14.4526 18.3333 15.8333 18.3333Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16669 6.66669V14.5834C4.16669 15.5 4.91669 16.25 5.83335 16.25H10.4167"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33331 18.3334L10.8333 16.25L8.33331 14.1667"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16669 6.66669C5.5474 6.66669 6.66669 5.5474 6.66669 4.16669C6.66669 2.78598 5.5474 1.66669 4.16669 1.66669C2.78598 1.66669 1.66669 2.78598 1.66669 4.16669C1.66669 5.5474 2.78598 6.66669 4.16669 6.66669Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HierarchyIcon2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      {...props}
    >
      <path
        d="M6.5 11.5V8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.62501 15C7.52247 15 8.25002 14.2724 8.25002 13.375C8.25002 12.4775 7.52247 11.75 6.62501 11.75C5.72755 11.75 5 12.4775 5 13.375C5 14.2724 5.72755 15 6.62501 15Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49999 8C7.32842 8 7.99998 7.32842 7.99998 6.49999C7.99998 5.67156 7.32842 5 6.49999 5C5.67156 5 5 5.67156 5 6.49999C5 7.32842 5.67156 8 6.49999 8Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 8C14.3284 8 15 7.32842 15 6.49999C15 5.67156 14.3284 5 13.5 5C12.6716 5 12 5.67156 12 6.49999C12 7.32842 12.6716 8 13.5 8Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.56665 11.5C6.79165 10.625 7.59164 9.97502 8.5333 9.98336L10.25 9.99167C11.5583 10 12.675 9.15834 13.0833 7.98334"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50002 1.66666H12.5C16.6667 1.66666 18.3334 3.33332 18.3334 7.49999V12.5C18.3334 16.6667 16.6667 18.3333 12.5 18.3333H7.50002C3.33335 18.3333 1.66669 16.6667 1.66669 12.5V7.49999C1.66669 3.33332 3.33335 1.66666 7.50002 1.66666Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ProviderReqIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      {...props}
    >
      <path d="M6.25002 10H9.16669V8.33333H7.50002V7.5H5.83335V8.375C4.88419 8.56833 4.16669 9.41 4.16669 10.4167C4.16669 11.565 5.10169 12.5 6.25002 12.5H7.08335C7.31335 12.5 7.50002 12.6867 7.50002 12.9167C7.50002 13.1467 7.31335 13.3333 7.08335 13.3333H4.16669V15H5.83335V15.8333H7.50002V14.9583C8.45085 14.765 9.16669 13.9233 9.16669 12.9167C9.16669 11.7683 8.23252 10.8333 7.08335 10.8333H6.25002C6.02085 10.8333 5.83335 10.6467 5.83335 10.4167C5.83335 10.1867 6.02085 10 6.25002 10Z" />
      <path d="M19.7559 1.42333L18.5775 0.244995L15.8334 2.98833V0.833328H14.1667V5.83333H19.1667V4.16666H17.0117L19.7559 1.42333Z" />
      <path d="M11.6667 17.8183L9.53917 16.7542C9.27083 16.6217 8.9525 16.6408 8.70417 16.8067L6.66667 18.165L4.62917 16.8067C4.49083 16.7142 4.32917 16.6667 4.16667 16.6667C4.04 16.6667 3.91167 16.6958 3.79417 16.7542L1.66667 17.8183V5.51584L3.79417 6.57751C4.06083 6.71168 4.38 6.69168 4.62917 6.52584L6.66667 5.16834L8.70417 6.52668C8.95333 6.69251 9.2725 6.71251 9.53917 6.57834L11.6667 5.51584V3.65168L9.22667 4.87168L7.12917 3.47334C6.84917 3.28668 6.485 3.28668 6.205 3.47334L4.1075 4.87251L1.20583 3.42084C0.948333 3.29251 0.641667 3.30751 0.395833 3.45834C0.15 3.61001 0 3.87751 0 4.16668V19.1667C0 19.4558 0.15 19.7233 0.395833 19.8767C0.529167 19.9583 0.681667 20 0.833333 20C0.960833 20 1.08917 19.9708 1.20583 19.9117L4.10667 18.4617L6.20417 19.86C6.48417 20.0467 6.84833 20.0467 7.12833 19.86L9.22667 18.4617L12.1267 19.9117C12.3858 20.0408 12.6925 20.0275 12.9383 19.8767C13.1842 19.7233 13.3333 19.4558 13.3333 19.1667V8.33334H11.6667V17.8183Z" />
    </svg>
  );
}

export function IntegrationIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      {...props}
    >
      <path d="M12.5 18.9583H7.50002C2.97502 18.9583 1.04169 17.025 1.04169 12.5V7.50001C1.04169 2.97501 2.97502 1.04167 7.50002 1.04167H12.5C17.025 1.04167 18.9584 2.97501 18.9584 7.50001V12.5C18.9584 17.025 17.025 18.9583 12.5 18.9583ZM7.50002 2.29167C3.65835 2.29167 2.29169 3.65834 2.29169 7.50001V12.5C2.29169 16.3417 3.65835 17.7083 7.50002 17.7083H12.5C16.3417 17.7083 17.7084 16.3417 17.7084 12.5V7.50001C17.7084 3.65834 16.3417 2.29167 12.5 2.29167H7.50002Z" />
      <path d="M7.99998 13.15C7.84165 13.15 7.68331 13.0917 7.55831 12.9667L5.48331 10.8917C4.99165 10.4 4.99165 9.60833 5.48331 9.11666L7.55831 7.04166C7.79998 6.8 8.19998 6.8 8.44165 7.04166C8.68331 7.28333 8.68331 7.68333 8.44165 7.925L6.36665 10L8.44165 12.0833C8.68331 12.325 8.68331 12.725 8.44165 12.9667C8.31665 13.0833 8.15831 13.15 7.99998 13.15Z" />
      <path d="M12 13.15C11.8417 13.15 11.6833 13.0917 11.5583 12.9667C11.3167 12.725 11.3167 12.325 11.5583 12.0833L13.6333 10L11.5583 7.91666C11.3167 7.675 11.3167 7.275 11.5583 7.03333C11.8 6.79166 12.2 6.79166 12.4417 7.03333L14.5167 9.10833C15.0083 9.6 15.0083 10.3917 14.5167 10.8833L12.4417 12.9583C12.325 13.0833 12.1583 13.15 12 13.15Z" />
    </svg>
  );
}

export function DragHandleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M11 18C11 19.1 10.1 20 9 20C7.9 20 7 19.1 7 18C7 16.9 7.9 16 9 16C10.1 16 11 16.9 11 18ZM9 10C7.9 10 7 10.9 7 12C7 13.1 7.9 14 9 14C10.1 14 11 13.1 11 12C11 10.9 10.1 10 9 10ZM9 4C7.9 4 7 4.9 7 6C7 7.1 7.9 8 9 8C10.1 8 11 7.1 11 6C11 4.9 10.1 4 9 4ZM15 8C16.1 8 17 7.1 17 6C17 4.9 16.1 4 15 4C13.9 4 13 4.9 13 6C13 7.1 13.9 8 15 8ZM15 10C13.9 10 13 10.9 13 12C13 13.1 13.9 14 15 14C16.1 14 17 13.1 17 12C17 10.9 16.1 10 15 10ZM15 16C13.9 16 13 16.9 13 18C13 19.1 13.9 20 15 20C16.1 20 17 19.1 17 18C17 16.9 16.1 16 15 16Z" />
    </svg>
  );
}

export function RectangleStack(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      width="20"
      height="20"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 6.878V6a2.25 2.25 0 012.25-2.25h7.5A2.25 2.25 0 0118 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 004.5 9v.878m13.5-3A2.25 2.25 0 0119.5 9v.878m0 0a2.246 2.246 0 00-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0121 12v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6c0-.98.626-1.813 1.5-2.122"
      />
    </svg>
  );
}

export function ArrowsUpDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      width="20"
      height="20"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
      />
    </svg>
  );
}

export function PercentageSquare(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 2H15C20 2 22 4 22 9V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.57007 15.27L15.11 8.72998"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.98001 10.37C9.65932 10.37 10.21 9.81936 10.21 9.14005C10.21 8.46073 9.65932 7.91003 8.98001 7.91003C8.3007 7.91003 7.75 8.46073 7.75 9.14005C7.75 9.81936 8.3007 10.37 8.98001 10.37Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.52 16.09C16.1993 16.09 16.75 15.5393 16.75 14.86C16.75 14.1807 16.1993 13.63 15.52 13.63C14.8407 13.63 14.29 14.1807 14.29 14.86C14.29 15.5393 14.8407 16.09 15.52 16.09Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ReceiptEdit(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.0834 9.41665V5.86667C17.0834 2.50834 16.3 1.66666 13.15 1.66666H6.85002C3.70002 1.66666 2.91669 2.50834 2.91669 5.86667V15.25C2.91669 17.4667 4.13336 17.9917 5.60836 16.4083L5.61668 16.4C6.30001 15.675 7.34168 15.7333 7.93334 16.525L8.77502 17.65"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66669 5.83334H13.3334"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 9.16666H12.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1758 12.3086L12.2258 15.2586C12.1092 15.3752 12.0008 15.5919 11.9758 15.7502L11.8175 16.8752C11.7592 17.2836 12.0425 17.5669 12.4508 17.5086L13.5758 17.3502C13.7342 17.3252 13.9592 17.2169 14.0675 17.1002L17.0175 14.1502C17.5258 13.6419 17.7675 13.0502 17.0175 12.3002C16.2758 11.5586 15.6842 11.8002 15.1758 12.3086Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7493 12.7336C14.9993 13.6336 15.6993 14.3336 16.5993 14.5836"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Transactions(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.333 12.5a5.829 5.829 0 0 1-5.833 5.833l.875-1.458M1.667 7.5A5.83 5.83 0 0 1 7.5 1.667l-.875 1.458M7.5 11.942c0 1.075.825 1.941 1.85 1.941h2.092c.891 0 1.616-.758 1.616-1.691 0-1.017-.441-1.375-1.1-1.609L8.6 9.417c-.658-.234-1.1-.592-1.1-1.609 0-.933.725-1.691 1.617-1.691h2.091c1.025 0 1.85.866 1.85 1.941M10.273 5v10"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Intents(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={20}
      viewBox="0 0 22 20"
      fill="none"
      {...props}
    >
      <path
        d="M7.667 18.333h6.666c4.167 0 5.834-1.666 5.834-5.833v-5c0-4.167-1.667-5.833-5.834-5.833H7.667C3.5 1.667 1.833 3.333 1.833 7.5v5c0 4.166 1.667 5.833 5.834 5.833Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.335 7.5H15.46M6.542 7.5H2.667"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M8.5 11.942c0 1.075.825 1.941 1.85 1.941h2.092c.891 0 1.616-.758 1.616-1.691 0-1.017-.441-1.375-1.1-1.609L9.6 9.417c-.658-.234-1.1-.592-1.1-1.609 0-.933.725-1.691 1.617-1.691h2.091c1.025 0 1.85.866 1.85 1.941M11.273 5v10"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CardPos(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        d="m3.275 13.733 9.958-9.959M9.251 15.732l1-1M11.494 13.49l1.992-1.991"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m3.001 9.033 5.533-5.534c1.767-1.766 2.65-1.775 4.4-.025l4.092 4.092c1.75 1.75 1.742 2.633-.025 4.4l-5.533 5.533c-1.767 1.767-2.65 1.775-4.4.025l-4.092-4.091c-1.75-1.75-1.75-2.625.025-4.4ZM1.667 18.832h16.666"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
